export default __webpack_public_path__ + "static/media/no-camera-icon.797de8bf.png";